// 服务名称： /order/mall
import { sysFetch } from '../fetch';
/**
 * 获取订单详情
 * @param data
 */
// export const featchDictionaryDetail = (id: string) =>
//   sysFetch.post<void, void>('/sysContentPage/query/industrialDictionary/detail', { id });
  export const featchDetail = data =>
  sysFetch.get(`/documentManage/mall/detail?id=${data.id}`);

  export const productInformation = data =>
  sysFetch.post(`/documentManage/productInfo/getByPage`, data);

  export const productInformationList = () =>
  sysFetch.post(`/documentManage/productInfo/getList`);

  export const fetchQueryDocumentClassifyList = (data) =>
  sysFetch.post('/documentClassify/mall/queryDocumentClassifyList', data);